import * as tslib_1 from "tslib";
var CandidateDocumentsController = /** @class */ (function () {
    /*@ngInject*/
    function CandidateDocumentsController($rootScope, $timeout, $uibModal, companyService, documentService, alertsAndNotificationsService, modalService, documentActionService, MESSAGECONSTANTS, sharedAjsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.companyService = companyService;
        this.documentService = documentService;
        this.modalService = modalService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.documentActionService = documentActionService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.sharedAjsService = sharedAjsService;
    }
    CandidateDocumentsController.prototype.$onInit = function () {
        var _this = this;
        this.userId = this.$rootScope.userDetails.id;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporate = this.companyService.isCorporateCompany();
        this.loadingFolders = true;
        this.isSharedDocumentActionAvailable = true;
        this.folders = [];
        this.allFoldersList = [];
        this.candidateJobMatchFolders = [];
        this.allAvailableDocuments = [];
        this.companiesToShareCandidateDocuments = [];
        this.getAllCandidateFolders(function () {
            if (_this.folders.length > 0) {
                if (_this.candidateDetails && _this.candidateDetails.folderId && _this.candidateDetails.isNotification) {
                    _this.onFolderSelect(_this._getFolderById(_this.candidateDetails.folderId));
                }
                else {
                    _this.onFolderSelect(_this.folders[0]);
                }
            }
        });
    };
    CandidateDocumentsController.prototype._setCandidateJobMatchFolders = function (jobMatches) {
        this.candidateJobMatchFolders = [];
        this.candidateJobMatchFolders = this.documentActionService.setCandidateJobMatchFolders(jobMatches, this.companyId, this.candidateId);
    };
    CandidateDocumentsController.prototype._setAllAvailableDocumentsInfolders = function () {
        var allDocuments = [];
        var parentDocuments = [];
        var childDocuments = [];
        this.folders.forEach(function (folder) {
            parentDocuments = tslib_1.__spread(folder.documents);
            childDocuments = [];
            folder.folders.forEach(function (subFolder) {
                childDocuments = tslib_1.__spread(childDocuments, subFolder.documents);
            });
            allDocuments = tslib_1.__spread(allDocuments, parentDocuments, childDocuments);
        });
        this.candidateJobMatchFolders.map(function (jobMatchFolder) {
            if (jobMatchFolder.documents.length > 0) {
                allDocuments.push.apply(allDocuments, tslib_1.__spread(jobMatchFolder.documents));
            }
        });
        this.allAvailableDocuments = allDocuments;
    };
    CandidateDocumentsController.prototype.getAllCandidateFolders = function (successCallback) {
        var _this = this;
        this.documentService.getAllCandidateFolders(this.candidateId, this.companyId, this.candidateType, function (data) {
            _this._setFolders(data.candidateDocuments);
            _this._setDocumentSharedOption(data);
            _this._setCandidateJobMatchFolders(data.jobMatchesDocuments);
            _this._setAllAvailableDocumentsInfolders();
            _this.folders = _this.documentActionService.setSharedFolderWithDocuments(_this.folders, _this.candidateId, _this.companyId);
            _this.companiesToShareCandidateDocuments = _this.setCompaniesToSharedCandidateDocuments(data);
            _this.loadingFolders = false;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateDocumentsController.prototype._setFolders = function (folders) {
        var _this = this;
        this.folders = [];
        folders.forEach(function (folder) {
            _this.allFoldersList.push(folder);
            folder.folders.forEach(function (subFolder) {
                subFolder.parentFolderId = folder.id;
                subFolder.parentFolderName = folder.name;
                _this.allFoldersList.push(subFolder);
            });
        });
        this.folders = folders;
        this.documentActionService._setDocumentIcons(this.folders);
    };
    CandidateDocumentsController.prototype.onFolderSelect = function (selectedFolder) {
        this.selectedFolder = selectedFolder;
        if (selectedFolder && selectedFolder.isJobMatchFolders) {
            this.candidateJobMatchFolders.map(function (jobMatchFolder) {
                jobMatchFolder.active = jobMatchFolder.id === selectedFolder.id;
            });
        }
        else {
            if (this.folders.length > 0) {
                this.folders.forEach(function (folder) {
                    folder.active = folder.id === (selectedFolder && selectedFolder.id);
                    folder.folders.forEach(function (sub) {
                        sub.active = sub.id === (selectedFolder && selectedFolder.id);
                    });
                });
            }
        }
    };
    CandidateDocumentsController.prototype.addDocumentFolder = function (parentFolder) {
        var _this = this;
        var actionType = 'addEditDocumentFolder';
        var actionLabel = 'Add Document Folder';
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-profile-modal");
        this.$timeout(function () {
            var candidateProfileActionsModal = _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: 'four-dot-five-modal-medium',
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: function () {
                        return actionType;
                    },
                    actionLabel: function () {
                        return actionLabel;
                    },
                    parentFolderName: function () {
                        return parentFolder ? parentFolder.name : null;
                    },
                    folder: function () {
                        return new Folder("", "", parentFolder ? parentFolder.id : null, _this.companyId, _this.candidateId);
                    },
                    folders: function () {
                        return _this.folders;
                    }
                }
            });
            candidateProfileActionsModal.result.then(function (callbackObject) {
                _this.getAllCandidateFolders(function () {
                    if (callbackObject && callbackObject.entity && callbackObject.entity.id) {
                        _this.onFolderSelect(_this._getFolderById(callbackObject.entity.id));
                    }
                    else if (_this.selectedFolder && _this.selectedFolder.id && !_this.selectedFolder.isJobMatchFolders) {
                        _this.onFolderSelect(_this._getFolderById(_this.selectedFolder.id));
                    }
                    else {
                        _this.onFolderSelect(_this.folders[0]);
                    }
                });
            }, function (dismiss) {
                //do nothing;
            });
        }, 300);
    };
    CandidateDocumentsController.prototype._getFolderById = function (folderId) {
        var parentFolder = this.folders.find(function (folder) { return folder.id === folderId; });
        if (parentFolder) {
            return parentFolder;
        }
        for (var i = 0; i < this.folders.length; i++) {
            var folder = this.folders[i];
            var subFolder = folder.folders.find(function (subFolder) { return subFolder.id === folderId; });
            if (subFolder !== undefined) {
                return subFolder;
                break;
            }
        }
    };
    CandidateDocumentsController.prototype.editDocumentFolder = function (folder) {
        var _this = this;
        var actionType = 'addEditDocumentFolder';
        var actionLabel = 'Edit Document Folder';
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-profile-modal");
        this.$timeout(function () {
            var candidateProfileActionsModal = _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: 'four-dot-five-modal-medium',
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: function () {
                        return actionType;
                    },
                    actionLabel: function () {
                        return actionLabel;
                    },
                    folder: function () {
                        return _.cloneDeep(folder);
                    },
                    folders: function () {
                        return _this.folders;
                    }
                }
            });
            candidateProfileActionsModal.result.then(function (callbackObject) {
                _this.getAllCandidateFolders(function () {
                    _this.onFolderSelect(_this._getFolderById(folder.id));
                });
            }, function (dismiss) {
            });
        }, 300);
    };
    CandidateDocumentsController.prototype.moveDocumentFolder = function (folder) {
        var _this = this;
        var spreadFolders = [];
        this.folders.forEach(function (parentFolder) {
            if (_this._notCurrentAndParentFolder(parentFolder, folder)) {
                spreadFolders.push(parentFolder);
            }
            folder.folders.forEach(function (subFolder) {
                if (_this._notCurrentAndParentFolder(subFolder, folder)) {
                    spreadFolders.push(subFolder);
                }
            });
        });
        if (folder.parentFolderId) {
            spreadFolders.push({ name: "Root", id: "root" });
        }
        if (spreadFolders.length === 0) {
            this.alertsAndNotificationsService.showAlert("No folders found", "No folders available.", "warning");
        }
        else {
            var actionType_1 = 'moveDocumentFolder';
            var actionLabel_1 = 'Move Folder';
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            $(".modal").addClass("candidate-profile-modal");
            this.$timeout(function () {
                var candidateProfileActionsModal = _this.$uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    backdrop: 'static',
                    windowTopClass: 'four-dot-five-modal-medium',
                    component: 'candidateProfileActionsModal',
                    resolve: {
                        actionType: function () {
                            return actionType_1;
                        },
                        actionLabel: function () {
                            return actionLabel_1;
                        },
                        folder: function () {
                            return folder;
                        },
                        parentFolders: function () {
                            return spreadFolders;
                        }
                    }
                });
                candidateProfileActionsModal.result.then(function (callbackObject) {
                    // if(callbackObject.entity.id){
                    _this.getAllCandidateFolders(function () {
                        _this.onFolderSelect(_this.folders[0]);
                    });
                    // }
                }, function (dismiss) {
                });
            }, 300);
        }
    };
    CandidateDocumentsController.prototype._notCurrentAndParentFolder = function (folder, folderToMove) {
        return folder.id !== folderToMove.id && folder.id !== folderToMove.parentFolderId && folder.parentFolderId !== folderToMove.id && folder.id !== 'sharedFolder';
    };
    CandidateDocumentsController.prototype.moveDocument = function (document) {
        var _this = this;
        var spreadFolders = [];
        this.folders.forEach(function (parentFolder) {
            if (parentFolder.id !== document.folderId && parentFolder.id !== 'sharedFolder') {
                spreadFolders.push(parentFolder);
            }
            parentFolder.folders.forEach(function (subFolder) {
                if (subFolder.id !== document.folderId) {
                    spreadFolders.push(subFolder);
                }
            });
        });
        if (spreadFolders.length === 0) {
            this.alertsAndNotificationsService.showAlert("No folders found", "No folders available.", "warning");
        }
        else {
            var sharedTo_1 = document && document.sharedTo ? document.sharedTo.map(function (document) { return document.id; }) : [];
            var actionType_2 = 'moveDocument';
            var actionLabel_2 = 'Move Document';
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            $(".modal").addClass("candidate-profile-modal");
            this.$timeout(function () {
                var candidateProfileActionsModal = _this.$uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    backdrop: 'static',
                    windowTopClass: 'four-dot-five-modal-medium',
                    component: 'candidateProfileActionsModal',
                    resolve: {
                        actionType: function () {
                            return actionType_2;
                        },
                        actionLabel: function () {
                            return actionLabel_2;
                        },
                        document: function () {
                            return new DocumentFile(document.id, document.fileName, "", _this.candidateId, _this.companyId, document.note, document.folderId, document.shared, "", sharedTo_1);
                        },
                        parentFolders: function () {
                            return spreadFolders;
                        },
                        candidateType: function () {
                            return _this.candidateType;
                        },
                        allFoldersList: function () {
                            return _this.allFoldersList;
                        },
                        candidateDetails: function () {
                            return _this.candidateDetails;
                        }
                    }
                });
                candidateProfileActionsModal.result.then(function (callbackObject) {
                    if (callbackObject.entity && callbackObject.entity.id) {
                        _this.getAllCandidateFolders(function () {
                            _this.onFolderSelect(_this._getFolderById(_this.selectedFolder.id));
                        });
                    }
                }, function (dismiss) {
                    //do nothing
                });
            }, 300);
        }
    };
    CandidateDocumentsController.prototype.deleteDocument = function (document) {
        var _this = this;
        this.documentActionService.setParentAndChildFolderName(this.allFoldersList, document);
        var deleteDocumentPayload = {};
        deleteDocumentPayload.candidateId = this.candidateId;
        deleteDocumentPayload.companyId = this.companyId;
        deleteDocumentPayload.folderId = document.folderId;
        deleteDocumentPayload.documentId = document.id;
        deleteDocumentPayload.userId = this.userId;
        deleteDocumentPayload.candidateType = this.candidateType;
        deleteDocumentPayload.keepLastVersion = false;
        deleteDocumentPayload.folderName = document.folderName;
        deleteDocumentPayload.parentFolderName = document.parentFolderName;
        deleteDocumentPayload.sharedEntityIds = document && document.sharedTo ? document.sharedTo.map(function (document) { return document.id; }).toString() : "";
        if (this.candidateDetails.jobMatchId) {
            deleteDocumentPayload.jobMatchId = this.candidateDetails.jobMatchId;
        }
        if (document.version === 1) {
            var message = "Are you sure you want to delete the document?";
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            this.alertsAndNotificationsService.showConfirm("Delete Document", message, "warning", false, function () {
                deleteDocumentPayload.keepLastVersion = false;
                _this.documentService.deleteCandidateDocument(deleteDocumentPayload, function () {
                    _this.getAllCandidateFolders(function () {
                        _this.onFolderSelect(_this._getFolderById(_this.selectedFolder.id));
                    });
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }, function (error) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                });
            }, function () {
                //do nothing
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            });
        }
        else {
            //delete candidate document
            var actionType_3 = 'deleteDocument';
            var actionLabel_3 = 'Delete Document';
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            $(".modal").addClass("candidate-profile-modal");
            this.$timeout(function () {
                var candidateProfileActionsModal = _this.$uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    backdrop: 'static',
                    windowTopClass: 'four-dot-five-modal-small',
                    component: 'candidateProfileActionsModal',
                    resolve: {
                        actionType: function () {
                            return actionType_3;
                        },
                        actionLabel: function () {
                            return actionLabel_3;
                        },
                        document: function () {
                            return new DocumentFile(document.id, document.fileName, "", _this.candidateId, _this.companyId, document.note, document.folderId, document.shared, "", []);
                        },
                        deleteDocumentPayload: function () {
                            return deleteDocumentPayload;
                        },
                        candidateDetails: function () {
                            return _this.candidateDetails;
                        }
                    }
                });
                candidateProfileActionsModal.result.then(function (callbackObject) {
                    _this.getAllCandidateFolders(function () {
                        if (_this.selectedFolder && _this.selectedFolder.id) {
                            _this.onFolderSelect(_this._getFolderById(_this.selectedFolder.id));
                        }
                    });
                }, function (dismiss) {
                    //do nothing;
                });
            }, 300);
        }
    };
    CandidateDocumentsController.prototype.deleteDocumentFolder = function (folder) {
        var _this = this;
        var message = "Are you sure you want to delete this folder?";
        var preMessage = "";
        var foldersCount = folder.folders.length;
        var documentsCount = folder.documents.length;
        if (foldersCount > 0 && documentsCount > 0) {
            var foldersMessage = foldersCount > 1 ? "There are " + foldersCount + " folders" : "There is " + foldersCount + " folder";
            var documentsMessage = documentsCount > 1 ? documentsCount + " documents" : documentsCount + " document";
            message = foldersMessage + " and " + documentsMessage + " in this folder.<br>" + message;
        }
        else if (foldersCount > 0) {
            preMessage = foldersCount > 1 ? "There are " + foldersCount + " folders in this folder."
                : "There is " + foldersCount + " folder in this folder.";
            message = preMessage + "<br>" + message;
        }
        else if (documentsCount > 0) {
            preMessage = documentsCount > 1 ? "There are " + documentsCount + " documents in this folder."
                : "There is " + documentsCount + " document in this folder.";
            message = preMessage + "<br>" + message;
        }
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        this.alertsAndNotificationsService.showConfirm("Delete Folder", message, "warning", false, function () {
            _this.documentService.deleteCandidateDocumentFolder(folder.id, function () {
                _this.getAllCandidateFolders(function () {
                    _this.onFolderSelect(_this.folders[0]);
                });
            }, function (error) {
                _this.alertsAndNotificationsService(error.message, "danger");
            });
            _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }, function () {
            //do nothing
            _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
    };
    CandidateDocumentsController.prototype.onAddDocument = function (document, action) {
        var _this = this;
        var actionType = 'uploadCandidateDocument';
        var actionLabel = 'Add Document';
        var showUpload = true;
        var windowTopClass = "four-dot-five-modal-medium";
        if (document) {
            actionLabel = 'Upload New Version';
        }
        if (action && action === "edit") {
            showUpload = false;
            actionLabel = 'Edit Document';
            windowTopClass = "four-dot-five-modal-small";
        }
        else if (action && action === "share") {
            showUpload = false;
            actionType = 'shareCandidateDocument';
            actionLabel = 'Share Document';
            windowTopClass = "four-dot-five-modal-small";
        }
        var documentToUpdate;
        var sharedTo = document && document.sharedTo ? document.sharedTo.map(function (document) { return document.id; }) : [];
        if (document) {
            documentToUpdate = new DocumentFile(document.id, document.fileName, "", this.candidateId, this.companyId, document.note, document.folderId, document.shared, "", sharedTo);
        }
        else {
            documentToUpdate = new DocumentFile(null, "", "", this.candidateId, this.companyId, "", this.selectedFolder.id, false, "", []);
        }
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-profile-modal");
        this.$timeout(function () {
            var candidateProfileActionsModal = _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: windowTopClass,
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: function () {
                        return actionType;
                    },
                    actionLabel: function () {
                        return actionLabel;
                    },
                    document: function () {
                        return documentToUpdate;
                    },
                    showUpload: function () {
                        return showUpload;
                    },
                    candidateType: function () {
                        return _this.candidateType;
                    },
                    candidateDetails: function () {
                        return _this.candidateDetails;
                    },
                    allFoldersList: function () {
                        return _this.allFoldersList;
                    },
                    isSharedDocumentActionAvailable: function () {
                        return _this.isSharedDocumentActionAvailable;
                    },
                    companiesToShareCandidateDocuments: function () {
                        return _this.companiesToShareCandidateDocuments;
                    }
                }
            });
            candidateProfileActionsModal.result.then(function (callbackObject) {
                _this.getAllCandidateFolders(function () {
                    _this.onFolderSelect(_this._getFolderById(_this.selectedFolder.id));
                });
            }, function (dismiss) {
                //do nothing;
            });
        }, 300);
    };
    CandidateDocumentsController.prototype.mailDocument = function (document) {
        var _this = this;
        var actionType = 'emailDocument';
        var actionLabel = 'Email Document';
        var windowTopClass = "four-dot-five-modal-extra-large";
        var documentToMail = document.isJobMatchDocument ? document : new DocumentFile(document.id, document.fileName, "", this.candidateId, this.companyId, document.note, document.folderId, document.shared, "", []);
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        $(".modal").addClass("candidate-profile-modal");
        this.$timeout(function () {
            var candidateProfileActionsModal = _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                backdrop: 'static',
                windowTopClass: windowTopClass,
                component: 'candidateProfileActionsModal',
                resolve: {
                    actionType: function () {
                        return actionType;
                    },
                    actionLabel: function () {
                        return actionLabel;
                    },
                    documents: function () {
                        return _.cloneDeep(_this.allAvailableDocuments);
                    },
                    document: function () {
                        return _.cloneDeep(documentToMail);
                    },
                    folders: function () {
                        return _.cloneDeep(_this.folders);
                    },
                    candidateJobMatchFolders: function () {
                        return _.cloneDeep(_this.candidateJobMatchFolders);
                    },
                    candidateDetails: function () {
                        return _this.candidateDetails;
                    },
                    sourceScreen: function () {
                        return _this.sourceScreen;
                    },
                    formalizeActivityPayload: function () {
                        return _this.formalizeActivityPayload;
                    }
                }
            });
        }, 300);
    };
    CandidateDocumentsController.prototype._setDocumentSharedOption = function (folderData) {
        if (this.candidateDetails) {
            // No sharing action if requisition is internal or external from workflow
            if (this.candidateDetails.context == 'candidateJobMatchCard' && !this.candidateDetails.isSharedRequisition) {
                this.isSharedDocumentActionAvailable = false;
                // No sharing action for corporate company internal candidates
            }
            else if (this.candidateDetails.context == 'candidateCard' && this.isCorporate && this.candidateDetails.candidateType == 'OWN_CANDIDATES') {
                this.isSharedDocumentActionAvailable = false;
                // Candidate screen No sharing action for candidates not in shared requisition
            }
            else if (this.candidateDetails.context == 'candidateCard' && !this.isCorporate) {
                this.isSharedDocumentActionAvailable = folderData.sharedCandidate;
            }
        }
    };
    CandidateDocumentsController.prototype.setCompaniesToSharedCandidateDocuments = function (data) {
        var _this = this;
        var companies = this.isCorporate ? data.documentToShareVendors : data.documentToShareCorporates;
        if (companies && companies.length > 1 && !this.isCorporate && this.candidateDetails.corporateName) {
            companies = companies.filter(function (company) { return _this.candidateDetails.corporateName == company.name; });
        }
        return companies;
    };
    CandidateDocumentsController.prototype.viewDocumentFIle = function (file) {
        this.sharedAjsService.viewDocumentFIle(file, function (data) {
        }, function (error) {
        });
    };
    return CandidateDocumentsController;
}());
CandidateDocumentsController.$inject = ['$rootScope', '$timeout', '$uibModal', 'companyService', 'documentService', 'alertsAndNotificationsService', 'modalService', 'documentActionService', 'MESSAGECONSTANTS', 'sharedAjsService'];
// import * as TEMPLATE from './candidate-documents.html';
import * as TEMPLATE from 'raw-loader!./candidate-documents.html';
export var CandidateDocumentsComponent = {
    selector: 'candidateDocuments',
    component: {
        bindings: {
            candidateId: '@',
            candidateType: '<',
            candidateDetails: '<',
            saveCallback: '&',
            cancelCallback: '&',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: CandidateDocumentsController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/candidate-documents.html'
    }
};
var Folder = /** @class */ (function () {
    function Folder(name, description, parentFolderId, companyId, candidateId) {
        this.name = name;
        this.description = description;
        this.parentFolderId = parentFolderId;
        this.companyId = companyId;
        this.candidateId = candidateId;
    }
    return Folder;
}());
var DocumentFile = /** @class */ (function () {
    function DocumentFile(id, name, description, candidateId, companyId, internalNote, folderId, shared, icon, sharedEntityIds) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.candidateId = candidateId;
        this.companyId = companyId;
        this.internalNote = internalNote;
        this.folderId = folderId;
        this.sharedEntityIds = sharedEntityIds;
        this.shared = shared;
        this.icon = icon;
    }
    return DocumentFile;
}());
//# sourceMappingURL=candidate-documents.component.js.map